<script>
  import WeekView from "./WeekView.svelte";
  import { _ } from "svelte-i18n";
  export let date;
  export let sessions;

  let monthName = date.toLocaleString("nb-NO", { month: "long" }); //"juli";
  let year = date.getFullYear();
  let month = date.getMonth();
  let firstDateInMonth = new Date(
    new Date(year, month, 1).toISOString().slice(0, 10)
  );

  function getWeeksInMonth(year, month) {
    const startDate = new Date(year, month, 1);
    const endDate = new Date(year, month + 1, 0);

    const startDayOfWeek = startDate.getDay();
    const daysInMonth = endDate.getDate();

    const numDaysInFirstWeek = 8 - (startDayOfWeek === 0 ? 7 : startDayOfWeek); // Number of days in the first week, accounting for Monday as the start of the week
    const remainingDays = daysInMonth - numDaysInFirstWeek; // Remaining days after the first week

    let numWeeks = 1;
    if (remainingDays > 0) {
      numWeeks += Math.ceil(remainingDays / 7);
    }

    return numWeeks;
  }
  let numberOfWeeks = getWeeksInMonth(year, month);

  function addWeeks(date, weeks) {
    if (weeks > 0) {
      const newDate = new Date(date.getTime());
      newDate.setDate(newDate.getDate() + (weeks - 1) * 7);

      // Find the difference between the current day and Monday (where Monday is considered as 1 and Sunday as 0)
      const currentDay = newDate.getDay();
      const daysUntilNextMonday = currentDay === 0 ? 1 : 8 - currentDay;

      // Adjust the date to the first Monday in the specified week
      newDate.setDate(newDate.getDate() + daysUntilNextMonday);

      return newDate;
    } else {
      return date;
    }
  }
</script>

<div class="calendar-month">
  <div class="calendar-month__header">
    <div class="summary-month">
      <button class="summary-month__button-toggle"
        ><span class="summary-month__year">{year}</span>
        <h2 class="summary-month__name">{monthName}</h2></button
      >
    </div>
    <div class="calendar-month__labels">
      <div class="calendar-week">
        <div class="calendar-week-overview calendar-week-overview--label">
          {$_("plans.nav.week")}
        </div>
        <div class="calendar-days">
          <div class="calendar-day calendar-day--header">{$_("days.short.monday")}</div>
          <div class="calendar-day calendar-day--header">{$_("days.short.tuesday")}</div>
          <div class="calendar-day calendar-day--header">{$_("days.short.wednesday")}</div>
          <div class="calendar-day calendar-day--header">{$_("days.short.thursday")}</div>
          <div class="calendar-day calendar-day--header">{$_("days.short.friday")}</div>
          <div
            class="calendar-day calendar-day--header calendar-day--is-weekend"
          >
          {$_("days.short.saturday")}
          </div>
          <div
            class="calendar-day calendar-day--header calendar-day--is-weekend"
          >
          {$_("days.short.sunday")}
          </div>
        </div>
      </div>
    </div>
  </div>
  {#each Array(numberOfWeeks) as _, index (index)}
    <WeekView
      {year}
      {month}
      firstDay={addWeeks(firstDateInMonth, index)}
      {sessions}
    />
  {/each}
  {#if false}
    <div class="calendar-week">
      <div class="calendar-training-period">
        <button class="calendar-training-period__button"
          ><span class="calendar-training-period__type" /></button
        >
      </div>
      <div class="calendar-week-overview">
        <div class="calendar-week__number">
          <a
            role="link"
            tabindex="0"
            class="calendar-week__load-button"
            style="cursor: pointer;"
          /><span class="calendar-week__number-text">31</span>
        </div>
        <div class="calendar-week-overview__inner-wrap">
          <div class="progress progress--week">
            <div>
              <div class="progress__label">
                <span><strong>1 økter.</strong> 5 planlagt.</span><span
                  >0 i årsplan.</span
                >
              </div>
              <div class="progress__bar">
                <div
                  class="progress__bar-done progress__bar-done--afterDone"
                  style="width: 20%;"
                />
                <div class="progress__bar-planned" style="left: 100%;" />
                <div class="progress__bar-track" />
              </div>
              <div />
            </div>
            <div>
              <div class="progress__label">
                <span><strong>1:00 timer.</strong> 3:45 planlagt.</span><span
                  >0 i årsplan.</span
                >
              </div>
              <div class="progress__bar">
                <div
                  class="progress__bar-done progress__bar-done--afterDone"
                  style="width: 27%;"
                />
                <div class="progress__bar-planned" style="left: 100%;" />
                <div class="progress__bar-track" />
              </div>
              <div />
            </div>
          </div>
          <div class="micrograph micrograph--week">
            <span class="micrograph__label">Fordeling per i-sone</span>
            <ul class="micrograph__list-bars">
              <li class="micrograph__izone micrograph__izone--1-three-izones">
                <span class="micrograph__planned" style="height: 0%;" /><span
                  class="micrograph__done"
                  style="height: 0%;"
                />
              </li>
              <li class="micrograph__izone micrograph__izone--2-three-izones">
                <span class="micrograph__planned" style="height: 0%;" /><span
                  class="micrograph__done"
                  style="height: 0%;"
                />
              </li>
              <li class="micrograph__izone micrograph__izone--3-three-izones">
                <span class="micrograph__planned" style="height: 0%;" /><span
                  class="micrograph__done"
                  style="height: 0%;"
                />
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="calendar-week__number-wrap">
        <div class="calendar-week__number-sm">
          <a
            role="link"
            tabindex="0"
            class="calendar-week__load-button"
            style="cursor: pointer;"
          /><span class="calendar-week__number-text">31</span>
        </div>
        <button class="calendar-week-overview__toggle-button"
          ><i class="calendar-week-overview__toggle-icon" /></button
        >
      </div>
      <div class="calendar-days">
        <div class="calendar-day calendar-day--is-focus-area-start">
          <a role="link" tabindex="0" class="calendar-day__button"
            ><div
              class="calendar-focus-area calendar-focus-area--start calendar-focus-area--resource"
            />
            <div class="calendar-day__header">
              <span
                class="calendar-day__number calendar-day__number--focus-area-start"
                >1</span
              ><button type="button" class="calendar-focus-area__button"
                ><span class="calendar-focus-area__name">Doble hopp</span
                ></button
              >
            </div>
            <ul class="list-activities" /></a
          >
        </div>
        <div class="calendar-day">
          <a role="link" tabindex="0" class="calendar-day__button"
            ><div class="calendar-focus-area calendar-focus-area--resource" />
            <div class="calendar-day__header">
              <span class="calendar-day__number">2</span>
            </div>
            <ul class="list-activities" /></a
          >
        </div>
        <div class="calendar-day">
          <a role="link" tabindex="0" class="calendar-day__button"
            ><div class="calendar-focus-area calendar-focus-area--resource" />
            <div class="calendar-day__header">
              <span class="calendar-day__number">3</span>
            </div>
            <ul class="list-activities" /></a
          >
        </div>
        <div class="calendar-day">
          <a role="link" tabindex="0" class="calendar-day__button"
            ><div class="calendar-focus-area calendar-focus-area--resource" />
            <div class="calendar-day__header">
              <span class="calendar-day__number">4</span>
            </div>
            <ul class="list-activities">
              <li class="list-activities__item list-activities__item--is-done">
                <a
                  class="list-activities__link"
                  href="/planer/måned/4490D164-509E-4CCA-B21D-B2784EE3E29C/A8882F5F-2B9C-43A2-AB65-2FC3E71303C8/2022-08-04/E1DA8828-9D6B-4D3A-B0D4-04290D890C98"
                  ><i
                    class="list-activities__icon list-activities__icon--check"
                  /><span class="list-activities__title"
                    ><span>Skating skills (08:45)</span></span
                  ><i
                    class="list-activities__icon
                list-activities__icon--comment-0"
                  /></a
                >
              </li>
              <li class="list-activities__item">
                <a
                  class="list-activities__link"
                  href="/planer/måned/4490D164-509E-4CCA-B21D-B2784EE3E29C/A8882F5F-2B9C-43A2-AB65-2FC3E71303C8/2022-08-04/B2DCF7A3-F870-4B2B-B204-EC424A2671EE"
                  ><span class="list-activities__title"
                    ><span>Dans (09:45)</span></span
                  ><i
                    class="list-activities__icon
                list-activities__icon--comment-0"
                  /></a
                >
              </li>
              <li class="list-activities__item">
                <a
                  class="list-activities__link"
                  href="/planer/måned/4490D164-509E-4CCA-B21D-B2784EE3E29C/A8882F5F-2B9C-43A2-AB65-2FC3E71303C8/2022-08-04/EC29C6EB-D528-4283-A699-DDE0F90C5AA1"
                  ><span class="list-activities__title"
                    ><span>Teknikk (12:00)</span></span
                  ><i
                    class="list-activities__icon
                list-activities__icon--comment-0"
                  /></a
                >
              </li>
              <li class="list-activities__item">
                <a
                  class="list-activities__link"
                  href="/planer/måned/4490D164-509E-4CCA-B21D-B2784EE3E29C/A8882F5F-2B9C-43A2-AB65-2FC3E71303C8/2022-08-04/EDA32891-FA63-45A4-9DAE-90D179990B27"
                  ><span class="list-activities__title"
                    ><span>Off-ice (13:45)</span></span
                  ><i
                    class="list-activities__icon
                list-activities__icon--comment-0"
                  /></a
                >
              </li>
              <li class="list-activities__item">
                <a
                  class="list-activities__link"
                  href="/planer/måned/4490D164-509E-4CCA-B21D-B2784EE3E29C/A8882F5F-2B9C-43A2-AB65-2FC3E71303C8/2022-08-04/24D3AC9D-85DF-4AED-8F4A-30B87FAB30E1"
                  ><span class="list-activities__title"
                    ><span>Spinns (16:15)</span></span
                  ><i
                    class="list-activities__icon
                list-activities__icon--comment-0"
                  /></a
                >
              </li>
            </ul></a
          >
        </div>
        <div class="calendar-day">
          <a role="link" tabindex="0" class="calendar-day__button"
            ><div class="calendar-focus-area calendar-focus-area--resource" />
            <div class="calendar-day__header">
              <span class="calendar-day__number">5</span>
            </div>
            <ul class="list-activities" /></a
          >
        </div>
        <div class="calendar-day calendar-day--is-weekend">
          <a role="link" tabindex="0" class="calendar-day__button"
            ><div class="calendar-focus-area calendar-focus-area--resource" />
            <div class="calendar-day__header">
              <span class="calendar-day__number">6</span>
            </div>
            <ul class="list-activities" /></a
          >
        </div>
        <div class="calendar-day calendar-day--is-weekend">
          <a role="link" tabindex="0" class="calendar-day__button"
            ><div class="calendar-focus-area calendar-focus-area--resource" />
            <div class="calendar-day__header">
              <span class="calendar-day__number">7</span>
            </div>
            <ul class="list-activities" /></a
          >
        </div>
      </div>
    </div>
    <div class="calendar-week">
      <div
        class="calendar-training-period calendar-training-period--start calendar-training-period--end"
      >
        <button class="calendar-training-period__button"
          ><span class="calendar-training-period__type">Treningsleir</span
          ></button
        >
      </div>
      <div class="calendar-week-overview">
        <div class="calendar-week__number">
          <a
            role="link"
            tabindex="0"
            class="calendar-week__load-button"
            style="cursor: pointer;"
          /><span class="calendar-week__number-text">32</span>
        </div>
        <div class="calendar-week-overview__inner-wrap">
          <div class="progress progress--week">
            <div>
              <div class="progress__label">
                <span><strong>1 økter.</strong> 10 planlagt.</span><span
                  >0 i årsplan.</span
                >
              </div>
              <div class="progress__bar">
                <div
                  class="progress__bar-done progress__bar-done--afterDone"
                  style="width: 10%;"
                />
                <div class="progress__bar-planned" style="left: 100%;" />
                <div class="progress__bar-track" />
              </div>
              <div />
            </div>
            <div>
              <div class="progress__label">
                <span><strong>0:45 timer.</strong> 7:30 planlagt.</span><span
                  >0 i årsplan.</span
                >
              </div>
              <div class="progress__bar">
                <div
                  class="progress__bar-done progress__bar-done--afterDone"
                  style="width: 10%;"
                />
                <div class="progress__bar-planned" style="left: 100%;" />
                <div class="progress__bar-track" />
              </div>
              <div />
            </div>
          </div>
          <div class="micrograph micrograph--week">
            <span class="micrograph__label">Fordeling per i-sone</span>
            <ul class="micrograph__list-bars">
              <li class="micrograph__izone micrograph__izone--1-three-izones">
                <span class="micrograph__planned" style="height: 0%;" /><span
                  class="micrograph__done"
                  style="height: 0%;"
                />
              </li>
              <li class="micrograph__izone micrograph__izone--2-three-izones">
                <span class="micrograph__planned" style="height: 0%;" /><span
                  class="micrograph__done"
                  style="height: 0%;"
                />
              </li>
              <li class="micrograph__izone micrograph__izone--3-three-izones">
                <span class="micrograph__planned" style="height: 0%;" /><span
                  class="micrograph__done"
                  style="height: 0%;"
                />
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="calendar-week__number-wrap">
        <div class="calendar-week__number-sm">
          <a
            role="link"
            tabindex="0"
            class="calendar-week__load-button"
            style="cursor: pointer;"
          /><span class="calendar-week__number-text">32</span>
        </div>
        <button class="calendar-week-overview__toggle-button"
          ><i class="calendar-week-overview__toggle-icon" /></button
        >
      </div>
      <div class="calendar-days">
        <div
          class="calendar-day calendar-day--is-event calendar-day--is-event-start"
        >
          <a role="link" tabindex="0" class="calendar-day__button"
            ><div
              class="calendar-focus-area calendar-focus-area--preparation"
            />
            <div class="calendar-day__header">
              <span class="calendar-day__number">8</span>
            </div>
            <ul class="list-activities">
              <li class="list-activities__item list-activities__item--is-done">
                <a
                  class="list-activities__link"
                  href="/planer/måned/4490D164-509E-4CCA-B21D-B2784EE3E29C/A8882F5F-2B9C-43A2-AB65-2FC3E71303C8/2022-08-08/9E9457EE-5F4F-4C08-A2E3-5C7787E54247"
                  ><i
                    class="list-activities__icon list-activities__icon--check"
                  /><span class="list-activities__title"
                    ><span>Skating skills (08:45)</span></span
                  ><i
                    class="list-activities__icon
                list-activities__icon--comment-0"
                  /></a
                >
              </li>
              <li class="list-activities__item">
                <a
                  class="list-activities__link"
                  href="/planer/måned/4490D164-509E-4CCA-B21D-B2784EE3E29C/A8882F5F-2B9C-43A2-AB65-2FC3E71303C8/2022-08-08/4BFC5AE5-3D29-404E-8AC9-CCB3F8DC0198"
                  ><span class="list-activities__title"
                    ><span>Dans (09:45)</span></span
                  ><i
                    class="list-activities__icon
                list-activities__icon--comment-0"
                  /></a
                >
              </li>
              <li class="list-activities__item">
                <a
                  class="list-activities__link"
                  href="/planer/måned/4490D164-509E-4CCA-B21D-B2784EE3E29C/A8882F5F-2B9C-43A2-AB65-2FC3E71303C8/2022-08-08/1234EA49-51A0-436E-9727-2E52C2EAF03A"
                  ><span class="list-activities__title"
                    ><span>Teknikk (12:00)</span></span
                  ><i
                    class="list-activities__icon
                list-activities__icon--comment-0"
                  /></a
                >
              </li>
              <li class="list-activities__item">
                <a
                  class="list-activities__link"
                  href="/planer/måned/4490D164-509E-4CCA-B21D-B2784EE3E29C/A8882F5F-2B9C-43A2-AB65-2FC3E71303C8/2022-08-08/DA9130E5-047C-41ED-896E-1B95A0339F77"
                  ><span class="list-activities__title"
                    ><span>Off-ice (13:45)</span></span
                  ><i
                    class="list-activities__icon
                list-activities__icon--comment-0"
                  /></a
                >
              </li>
              <li class="list-activities__item">
                <a
                  class="list-activities__link"
                  href="/planer/måned/4490D164-509E-4CCA-B21D-B2784EE3E29C/A8882F5F-2B9C-43A2-AB65-2FC3E71303C8/2022-08-08/476DB18B-8950-47B1-8411-E21FFA8E9A89"
                  ><span class="list-activities__title"
                    ><span>Spinns (16:15)</span></span
                  ><i
                    class="list-activities__icon
                list-activities__icon--comment-0"
                  /></a
                >
              </li>
            </ul>
            <button
              class="calendar-event calendar-event--start calendar-event--meet"
              ><div class="calendar-event__block">
                <h4 class="calendar-event__title">Sommeris</h4>
              </div>
              <p class="calendar-event__description">Sommeris</p></button
            ></a
          >
        </div>
        <div class="calendar-day calendar-day--is-event">
          <a role="link" tabindex="0" class="calendar-day__button"
            ><div
              class="calendar-focus-area calendar-focus-area--preparation"
            />
            <div class="calendar-day__header">
              <span class="calendar-day__number">9</span>
            </div>
            <ul class="list-activities">
              <li class="list-activities__item">
                <a
                  class="list-activities__link"
                  href="/planer/måned/4490D164-509E-4CCA-B21D-B2784EE3E29C/A8882F5F-2B9C-43A2-AB65-2FC3E71303C8/2022-08-09/EF55FDBD-7E02-4081-9425-DEA4A15D1C84"
                  ><span class="list-activities__title"
                    ><span>Skating skills (07:00)</span></span
                  ><i
                    class="list-activities__icon
                list-activities__icon--comment-0"
                  /></a
                >
              </li>
              <li class="list-activities__item">
                <a
                  class="list-activities__link"
                  href="/planer/måned/4490D164-509E-4CCA-B21D-B2784EE3E29C/A8882F5F-2B9C-43A2-AB65-2FC3E71303C8/2022-08-09/22F31CDD-318C-4F17-A3DB-2DA1F99990ED"
                  ><span class="list-activities__title"
                    ><span>Dans (08:00)</span></span
                  ><i
                    class="list-activities__icon
                list-activities__icon--comment-0"
                  /></a
                >
              </li>
              <li class="list-activities__item">
                <a
                  class="list-activities__link"
                  href="/planer/måned/4490D164-509E-4CCA-B21D-B2784EE3E29C/A8882F5F-2B9C-43A2-AB65-2FC3E71303C8/2022-08-09/499814D9-F7F2-49EB-ADEE-F4BD3A2C3DDA"
                  ><span class="list-activities__title"
                    ><span>Off-ice (09:00)</span></span
                  ><i
                    class="list-activities__icon
                list-activities__icon--comment-0"
                  /></a
                >
              </li>
              <li class="list-activities__item">
                <a
                  class="list-activities__link"
                  href="/planer/måned/4490D164-509E-4CCA-B21D-B2784EE3E29C/A8882F5F-2B9C-43A2-AB65-2FC3E71303C8/2022-08-09/B71F97E7-5E88-4CA3-B319-7520EA8F8AF6"
                  ><span class="list-activities__title"
                    ><span>Teknikk (10:30)</span></span
                  ><i
                    class="list-activities__icon
                list-activities__icon--comment-0"
                  /></a
                >
              </li>
              <li class="list-activities__item">
                <a
                  class="list-activities__link"
                  href="/planer/måned/4490D164-509E-4CCA-B21D-B2784EE3E29C/A8882F5F-2B9C-43A2-AB65-2FC3E71303C8/2022-08-09/C2AFF334-DD43-4FD6-A7A6-496D9766BAEC"
                  ><span class="list-activities__title"
                    ><span>Spinns (13:45)</span></span
                  ><i
                    class="list-activities__icon
                list-activities__icon--comment-0"
                  /></a
                >
              </li>
            </ul>
            <button class="calendar-event calendar-event--meet"
              ><div class="calendar-event__block">
                <h4 class="calendar-event__title">Sommeris</h4>
              </div>
              <p class="calendar-event__description">Sommeris</p></button
            ></a
          >
        </div>
        <div class="calendar-day calendar-day--is-event">
          <a role="link" tabindex="0" class="calendar-day__button"
            ><div
              class="calendar-focus-area calendar-focus-area--preparation"
            />
            <div class="calendar-day__header">
              <span class="calendar-day__number">10</span>
            </div>
            <ul class="list-activities" />
            <button class="calendar-event calendar-event--meet"
              ><div class="calendar-event__block">
                <h4 class="calendar-event__title">Sommeris</h4>
              </div>
              <p class="calendar-event__description">Sommeris</p></button
            ></a
          >
        </div>
        <div class="calendar-day calendar-day--is-event">
          <a role="link" tabindex="0" class="calendar-day__button"
            ><div
              class="calendar-focus-area calendar-focus-area--preparation"
            />
            <div class="calendar-day__header">
              <span class="calendar-day__number">11</span>
            </div>
            <ul class="list-activities" />
            <button class="calendar-event calendar-event--meet"
              ><div class="calendar-event__block">
                <h4 class="calendar-event__title">Sommeris</h4>
              </div>
              <p class="calendar-event__description">Sommeris</p></button
            ></a
          >
        </div>
        <div class="calendar-day calendar-day--is-event">
          <a role="link" tabindex="0" class="calendar-day__button"
            ><div
              class="calendar-focus-area calendar-focus-area--preparation"
            />
            <div class="calendar-day__header">
              <span class="calendar-day__number">12</span>
            </div>
            <ul class="list-activities" />
            <button
              class="calendar-event calendar-event--end calendar-event--meet"
              ><div class="calendar-event__block">
                <h4 class="calendar-event__title">Sommeris</h4>
              </div>
              <p class="calendar-event__description">Sommeris</p></button
            ></a
          >
        </div>
        <div class="calendar-day calendar-day--is-weekend">
          <a role="link" tabindex="0" class="calendar-day__button"
            ><div class="calendar-focus-area calendar-focus-area--resource" />
            <div class="calendar-day__header">
              <span class="calendar-day__number">13</span>
            </div>
            <ul class="list-activities" /></a
          >
        </div>
        <div class="calendar-day calendar-day--is-weekend">
          <a role="link" tabindex="0" class="calendar-day__button"
            ><div class="calendar-focus-area calendar-focus-area--resource" />
            <div class="calendar-day__header">
              <span class="calendar-day__number">14</span>
            </div>
            <ul class="list-activities" /></a
          >
        </div>
      </div>
    </div>
    <div class="calendar-week">
      <div class="calendar-training-period">
        <button class="calendar-training-period__button"
          ><span class="calendar-training-period__type" /></button
        >
      </div>
      <div class="calendar-week-overview">
        <div class="calendar-week__number">
          <a
            role="link"
            tabindex="0"
            class="calendar-week__load-button"
            style="cursor: pointer;"
          /><span class="calendar-week__number-text">33</span>
        </div>
        <div class="calendar-week-overview__inner-wrap">
          <div class="progress progress--week">
            <div>
              <div class="progress__label">
                <span><strong>0 økter.</strong> 0 planlagt.</span><span
                  >0 i årsplan.</span
                >
              </div>
              <div class="progress__bar">
                <div class="progress__bar-done" style="width: 0%;" />
                <div class="progress__bar-planned" style="left: 0%;" />
              </div>
              <div />
            </div>
            <div>
              <div class="progress__label">
                <span
                  ><strong> timer.</strong>
                  planlagt.</span
                ><span>0 i årsplan.</span>
              </div>
              <div class="progress__bar">
                <div class="progress__bar-done" style="width: 0%;" />
                <div class="progress__bar-planned" style="left: 0%;" />
              </div>
              <div />
            </div>
          </div>
          <div class="micrograph micrograph--week">
            <span class="micrograph__label">Fordeling per i-sone</span>
            <ul class="micrograph__list-bars">
              <li class="micrograph__izone micrograph__izone--1-three-izones">
                <span class="micrograph__planned" style="height: 0%;" /><span
                  class="micrograph__done"
                  style="height: 0%;"
                />
              </li>
              <li class="micrograph__izone micrograph__izone--2-three-izones">
                <span class="micrograph__planned" style="height: 0%;" /><span
                  class="micrograph__done"
                  style="height: 0%;"
                />
              </li>
              <li class="micrograph__izone micrograph__izone--3-three-izones">
                <span class="micrograph__planned" style="height: 0%;" /><span
                  class="micrograph__done"
                  style="height: 0%;"
                />
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="calendar-week__number-wrap">
        <div class="calendar-week__number-sm">
          <a
            role="link"
            tabindex="0"
            class="calendar-week__load-button"
            style="cursor: pointer;"
          /><span class="calendar-week__number-text">33</span>
        </div>
        <button class="calendar-week-overview__toggle-button"
          ><i class="calendar-week-overview__toggle-icon" /></button
        >
      </div>
      <div class="calendar-days">
        <div class="calendar-day">
          <a role="link" tabindex="0" class="calendar-day__button"
            ><div class="calendar-focus-area calendar-focus-area--resource" />
            <div class="calendar-day__header">
              <span class="calendar-day__number">15</span>
            </div>
            <ul class="list-activities" /></a
          >
        </div>
        <div class="calendar-day">
          <a role="link" tabindex="0" class="calendar-day__button"
            ><div class="calendar-focus-area calendar-focus-area--resource" />
            <div class="calendar-day__header">
              <span class="calendar-day__number">16</span>
            </div>
            <ul class="list-activities" /></a
          >
        </div>
        <div class="calendar-day">
          <a role="link" tabindex="0" class="calendar-day__button"
            ><div class="calendar-focus-area calendar-focus-area--resource" />
            <div class="calendar-day__header">
              <span class="calendar-day__number">17</span>
            </div>
            <ul class="list-activities" /></a
          >
        </div>
        <div class="calendar-day">
          <a role="link" tabindex="0" class="calendar-day__button"
            ><div class="calendar-focus-area calendar-focus-area--resource" />
            <div class="calendar-day__header">
              <span class="calendar-day__number">18</span>
            </div>
            <ul class="list-activities" /></a
          >
        </div>
        <div class="calendar-day">
          <a role="link" tabindex="0" class="calendar-day__button"
            ><div class="calendar-focus-area calendar-focus-area--resource" />
            <div class="calendar-day__header">
              <span class="calendar-day__number">19</span>
            </div>
            <ul class="list-activities" /></a
          >
        </div>
        <div class="calendar-day calendar-day--is-weekend">
          <a role="link" tabindex="0" class="calendar-day__button"
            ><div class="calendar-focus-area calendar-focus-area--resource" />
            <div class="calendar-day__header">
              <span class="calendar-day__number">20</span>
            </div>
            <ul class="list-activities" /></a
          >
        </div>
        <div class="calendar-day calendar-day--is-weekend">
          <a role="link" tabindex="0" class="calendar-day__button"
            ><div class="calendar-focus-area calendar-focus-area--resource" />
            <div class="calendar-day__header">
              <span class="calendar-day__number">21</span>
            </div>
            <ul class="list-activities" /></a
          >
        </div>
      </div>
    </div>
    <div class="calendar-week">
      <div class="calendar-training-period">
        <button class="calendar-training-period__button"
          ><span class="calendar-training-period__type" /></button
        >
      </div>
      <div class="calendar-week-overview">
        <div class="calendar-week__number">
          <a
            role="link"
            tabindex="0"
            class="calendar-week__load-button"
            style="cursor: pointer;"
          /><span class="calendar-week__number-text">34</span>
        </div>
        <div class="calendar-week-overview__inner-wrap">
          <div class="progress progress--week">
            <div>
              <div class="progress__label">
                <span><strong>0 økter.</strong> 0 planlagt.</span><span
                  >0 i årsplan.</span
                >
              </div>
              <div class="progress__bar">
                <div class="progress__bar-done" style="width: 0%;" />
                <div class="progress__bar-planned" style="left: 0%;" />
              </div>
              <div />
            </div>
            <div>
              <div class="progress__label">
                <span
                  ><strong> timer.</strong>
                  planlagt.</span
                ><span>0 i årsplan.</span>
              </div>
              <div class="progress__bar">
                <div class="progress__bar-done" style="width: 0%;" />
                <div class="progress__bar-planned" style="left: 0%;" />
              </div>
              <div />
            </div>
          </div>
          <div class="micrograph micrograph--week">
            <span class="micrograph__label">Fordeling per i-sone</span>
            <ul class="micrograph__list-bars">
              <li class="micrograph__izone micrograph__izone--1-three-izones">
                <span class="micrograph__planned" style="height: 0%;" /><span
                  class="micrograph__done"
                  style="height: 0%;"
                />
              </li>
              <li class="micrograph__izone micrograph__izone--2-three-izones">
                <span class="micrograph__planned" style="height: 0%;" /><span
                  class="micrograph__done"
                  style="height: 0%;"
                />
              </li>
              <li class="micrograph__izone micrograph__izone--3-three-izones">
                <span class="micrograph__planned" style="height: 0%;" /><span
                  class="micrograph__done"
                  style="height: 0%;"
                />
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="calendar-week__number-wrap">
        <div class="calendar-week__number-sm">
          <a
            role="link"
            tabindex="0"
            class="calendar-week__load-button"
            style="cursor: pointer;"
          /><span class="calendar-week__number-text">34</span>
        </div>
        <button class="calendar-week-overview__toggle-button"
          ><i class="calendar-week-overview__toggle-icon" /></button
        >
      </div>
      <div class="calendar-days">
        <div class="calendar-day">
          <a role="link" tabindex="0" class="calendar-day__button"
            ><div class="calendar-focus-area calendar-focus-area--resource" />
            <div class="calendar-day__header">
              <span class="calendar-day__number">22</span>
            </div>
            <ul class="list-activities" /></a
          >
        </div>
        <div class="calendar-day">
          <a role="link" tabindex="0" class="calendar-day__button"
            ><div class="calendar-focus-area calendar-focus-area--resource" />
            <div class="calendar-day__header">
              <span class="calendar-day__number">23</span>
            </div>
            <ul class="list-activities" /></a
          >
        </div>
        <div class="calendar-day">
          <a role="link" tabindex="0" class="calendar-day__button"
            ><div class="calendar-focus-area calendar-focus-area--resource" />
            <div class="calendar-day__header">
              <span class="calendar-day__number">24</span>
            </div>
            <ul class="list-activities" /></a
          >
        </div>
        <div class="calendar-day">
          <a role="link" tabindex="0" class="calendar-day__button"
            ><div class="calendar-focus-area calendar-focus-area--resource" />
            <div class="calendar-day__header">
              <span class="calendar-day__number">25</span>
            </div>
            <ul class="list-activities" /></a
          >
        </div>
        <div class="calendar-day">
          <a role="link" tabindex="0" class="calendar-day__button"
            ><div class="calendar-focus-area calendar-focus-area--resource" />
            <div class="calendar-day__header">
              <span class="calendar-day__number">26</span>
            </div>
            <ul class="list-activities" /></a
          >
        </div>
        <div class="calendar-day calendar-day--is-weekend">
          <a role="link" tabindex="0" class="calendar-day__button"
            ><div class="calendar-focus-area calendar-focus-area--resource" />
            <div class="calendar-day__header">
              <span class="calendar-day__number">27</span>
            </div>
            <ul class="list-activities" /></a
          >
        </div>
        <div class="calendar-day calendar-day--is-weekend">
          <a role="link" tabindex="0" class="calendar-day__button"
            ><div class="calendar-focus-area calendar-focus-area--resource" />
            <div class="calendar-day__header">
              <span class="calendar-day__number">28</span>
            </div>
            <ul class="list-activities" /></a
          >
        </div>
      </div>
    </div>
    <div class="calendar-week">
      <div class="calendar-training-period">
        <button class="calendar-training-period__button"
          ><span class="calendar-training-period__type" /></button
        >
      </div>
      <div class="calendar-week-overview">
        <div class="calendar-week__number">
          <a
            role="link"
            tabindex="0"
            class="calendar-week__load-button"
            style="cursor: pointer;"
          /><span class="calendar-week__number-text">35</span>
        </div>
        <div class="calendar-week-overview__inner-wrap">
          <div class="progress progress--week">
            <div>
              <div class="progress__label">
                <span><strong>0 økter.</strong> 0 planlagt.</span><span
                  >0 i årsplan.</span
                >
              </div>
              <div class="progress__bar">
                <div class="progress__bar-done" style="width: 0%;" />
                <div class="progress__bar-planned" style="left: 0%;" />
              </div>
              <div />
            </div>
            <div>
              <div class="progress__label">
                <span
                  ><strong> timer.</strong>
                  planlagt.</span
                ><span>0 i årsplan.</span>
              </div>
              <div class="progress__bar">
                <div class="progress__bar-done" style="width: 0%;" />
                <div class="progress__bar-planned" style="left: 0%;" />
              </div>
              <div />
            </div>
          </div>
          <div class="micrograph micrograph--week">
            <span class="micrograph__label">Fordeling per i-sone</span>
            <ul class="micrograph__list-bars">
              <li class="micrograph__izone micrograph__izone--1-three-izones">
                <span class="micrograph__planned" style="height: 0%;" /><span
                  class="micrograph__done"
                  style="height: 0%;"
                />
              </li>
              <li class="micrograph__izone micrograph__izone--2-three-izones">
                <span class="micrograph__planned" style="height: 0%;" /><span
                  class="micrograph__done"
                  style="height: 0%;"
                />
              </li>
              <li class="micrograph__izone micrograph__izone--3-three-izones">
                <span class="micrograph__planned" style="height: 0%;" /><span
                  class="micrograph__done"
                  style="height: 0%;"
                />
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="calendar-week__number-wrap">
        <div class="calendar-week__number-sm">
          <a
            role="link"
            tabindex="0"
            class="calendar-week__load-button"
            style="cursor: pointer;"
          /><span class="calendar-week__number-text">35</span>
        </div>
        <button class="calendar-week-overview__toggle-button"
          ><i class="calendar-week-overview__toggle-icon" /></button
        >
      </div>
      <div class="calendar-days">
        <div class="calendar-day">
          <a role="link" tabindex="0" class="calendar-day__button"
            ><div class="calendar-focus-area calendar-focus-area--resource" />
            <div class="calendar-day__header">
              <span class="calendar-day__number">29</span>
            </div>
            <ul class="list-activities" /></a
          >
        </div>
        <div class="calendar-day">
          <a role="link" tabindex="0" class="calendar-day__button"
            ><div class="calendar-focus-area calendar-focus-area--resource" />
            <div class="calendar-day__header">
              <span class="calendar-day__number">30</span>
            </div>
            <ul class="list-activities" /></a
          >
        </div>
        <div class="calendar-day">
          <a role="link" tabindex="0" class="calendar-day__button"
            ><div
              class="calendar-focus-area calendar-focus-area--end calendar-focus-area--resource"
            />
            <div class="calendar-day__header">
              <span class="calendar-day__number">31</span>
            </div>
            <ul class="list-activities" /></a
          >
        </div>
        <div class="calendar-day calendar-day--is-empty" />
        <div class="calendar-day calendar-day--is-empty" />
        <div class="calendar-day calendar-day--is-empty" />
        <div class="calendar-day calendar-day--is-empty" />
      </div>
    </div>
  {/if}
</div>
